module.exports = __webpack_public_path__ + "@/assets/img/logo-teclab.43fade55.png";